/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CompEvent} from "../../models/CompEvent";
import {CompetitionService} from "../../providers/competition-service";


@Component({
  selector: 'event-list-item',
  templateUrl: 'event-list-item.html'
})
export class EventListItem implements OnInit {

  @Input()
  event: CompEvent;

  @Output()
  eventSelected: EventEmitter<CompEvent> = new EventEmitter();

  constructor(private compService: CompetitionService) {
    console.log('Hello EventListItem Component');

  }

  ngOnInit(): void {
    // get competition
    this.compService.getCompetitionById(this.event.competition.id).then(comp => {
      this.event.competition = comp;
    });
  }

  select() {
    this.eventSelected.next(this.event);
  }

}



// WEBPACK FOOTER //
// ./src/components/event-list-item/event-list-item.ts